import { MeterNotFoundError, UnexpectedError } from "../../../domain/errors";
import { MeterAlreadyRegisteredError } from "../../../domain/errors/meter-already-exists-error";
import { AddMeters } from "../../../domain/usecases/add-meters";
import { HttpClient, HttpStatusCode } from "../../protocols/http";

export class RemoteAddMeters implements AddMeters {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<void>
  ) {}

  async add(params: AddMeters.Params): Promise<void> {
    console.log("AddMeters.Params", params);
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body!;
      case HttpStatusCode.notFound:
        throw new MeterNotFoundError();
      case HttpStatusCode.conflict:
        throw new MeterAlreadyRegisteredError();
      default:
        throw new UnexpectedError();
    }
  }
}

// export namespace RemoteAddAccount {
//   export type Model = CreateUser.Model;
// }
